import React from 'react';
import PropTypes from 'prop-types';

function CardTitle(props) {
    const { className, content, children } = props;

    return (
        <div className={`kbe-card-title ${className}`}>
            <span>{content || children}</span>
        </div>
    );
}

CardTitle.defaultProps = {
    className : '',
    content   : null,
    children  : null,
};

CardTitle.propTypes = {
    className : PropTypes.string,
    content   : PropTypes.oneOfType([ PropTypes.string, PropTypes.node ]),
    children  : PropTypes.oneOfType([ PropTypes.string, PropTypes.node ]),
};

export default CardTitle;
